<template>
	<div class="message">
		<van-nav-bar :title="title" fixed border>
			<template #left>
				<img src="../../assets/img/icon/left-arrow.png" class="icon" @click="goBack()" />
			</template>
		</van-nav-bar>
		<div class="collapse">
			<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    			<div class="empty" v-if="items.length==0"><span class="msg">暂无信息</span></div>
				<van-list
				v-model="loading"
				:finished="finished"
				:finished-text="items.length==0?'':'没有更多信息了'"
				@load="loadData"
				>
				<div class="col-item" v-for="(item, index) in items" :key="index" @click="showDetail(item,index)">
					<div class="msg">
						<div class="topic">
							<img v-if="item.state == 2" src="../../assets/img/icon/gray-m.png" alt />
							<img v-else src="../../assets/img/icon/message.png" alt />
							<span class="title">{{item.title}}</span>
						</div>
						<span class="time">{{item.create_time*1000|moment_format('Y-M-D HH:mm:ss')}}</span>
					</div>
					<div :class="{'content':true, 'message_content':true, 'van-multi-ellipsis--l2':index!=viewMessageIndex}">{{item.content}}</div>
					<div class="content message_link" v-if="item.link"><a href="javascript:void(0)" @click.stop="toNewLink(item.link)" class="skin_color">详情</a></div>
				</div>
				</van-list>
			</van-pull-refresh>
		</div>
	</div>
</template>

<style scoped>
</style>

<script type="text/ecmascript-6">
import { goodUnit,chkURL } from "@/utils/common.js";
import { List } from "vant";
export default {
	name: "message",
	components: {
		"van-list": List,
	},
	data() {
		return {
			title: "信息中心",
			items: [],
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			page:0,
			pageSize:0,
			total:0,
			loading: false,
			finished: false,
			refreshing: false,
			viewMessageIndex:-1
		};
	},
	mounted() {
		// 获取浏览器可视区域高度
		this.winH = `${document.documentElement.clientHeight}`;
		window.onresize = function temp() {
			this.winH = `${document.documentElement.clientHeight}`;
		};
	},
	created() {
		this.loadData();
	},
	methods: {
		goBack() {
			this.$router.go(-1);
		},
		loadData() {
			if (this.finished) {
				return false;
			}
			this.loading = true;
			if (this.refreshing) {
				this.items = [];
				this.refreshing = false;
			}
			this.page = this.page+1;
			var params = {
				u_id: this.u_id,
				token: this.token,
				page:this.page
			};
			var url = this.Conf.serverUrl + "userInfoCenter/getInfoCenter" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				this.loading = false;
				if (response.data.page == 1) {
					this.pageSize = response.data.pageSize;
					this.total = response.data.total;
					this.items = response.data.infos;
				}else if(response.data.infos){
					this.items = this.items.concat(response.data.infos);
				}
				if(this.page*this.pageSize >= this.total){
					this.finished = true;
				}
			})
			.catch(error => {});
		},
		onRefresh(cur) {
			this.finished = false;
			this.page = cur?(this.page-1):0;
			this.items.splice(this.page*this.pageSize);
			this.loadData();
		},
		markReadMsg(item){
			if(item.state!=2){
				var params = {
					u_id: this.u_id,
					token: this.token,
					info_id: item.id
				};
				var url = this.Conf.serverUrl + "userInfoCenter/upMarkRead" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					switch (response.data.code) {
						case 200:
							//this.onRefresh(true);
							this.items[this.viewMessageIndex].state = 2;
							break;
						case 40001:
							this.$toast.fail(response.data.msg);
							break;
						default:
							this.$toast.fail(response.data.msg);
							return;
					}
				})
				.catch(error => {});
			}
		},
		showDetail(item,ind) {
			if(this.viewMessageIndex == ind){
				this.viewMessageIndex = -1;
			}else{
				this.viewMessageIndex = ind
				this.markReadMsg(item);
			}
		},
		toNewLink(link){
			if(chkURL(link)){
				if (window.plus) {
					plus.runtime.openURL(link);
				} else {
					window.open(link);
				}
			}else{
				this.$router.push({ path: link });
			}
		}
	}
};
</script>




// WEBPACK FOOTER //
// src/components/My/Message.vue